<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'MemberEbooks' }">我的电子书</router-link>
      <span class="slash">/</span>
      <span class="current" v-if="bookInfo">{{ bookInfo.name }}</span>
    </div>
    <div class="page-reader">
      <div class="book-header">
        <div class="book-header-left">
          <img src="../../images/book/icon-back.png" alt="" class="" @click="onBack" />
          <p class="tool-tip tool-tip-back">退出读书</p>
          <p class="book-name" v-if="bookInfo">{{ bookInfo.name }}</p>
          <p class="book-chapter" v-if="chapter">
            {{ chapter.document ? chapter.document.title : '' }}
          </p>
        </div>
        <div class="book-mark">
          <p class="add-note-tip">添加书签</p>
          <img
            src="../../images/book/icon-markbook.png"
            alt=""
            class=""
            v-if="!isMarked"
            @click="addBookmark"
          />
          <img
            src="../../images/book/icon_bookmark_active.png"
            alt=""
            class=""
            v-if="isMarked"
            @click="removeBookMarkIcon"
          />
        </div>
      </div>
      <div id="wrapper" v-loading="loading">
        <div id="area"></div>
        <!-- <div class="page-divider"></div> -->
        <div class="rightSide">
          <div class="side-wrap side-wrap-next" @click="next" v-if="book" id="next">
            <img src="../../images/book/icon-next.png" alt="" class="" />
            <p class="tool-tip tool-tip-next">下一页</p>
          </div>
          <div class="side-wrap side-wrap-prev" @click.stop="prev" v-if="book" id="prev">
            <img src="../../images/book/icon-prev.png" alt="" class="" />
            <p class="tool-tip tool-tip-prev">上一页</p>
          </div>
          <div class="side-wrap side-wrap-menu" @click.stop="toggle(0)">
            <img src="../../images/book/icon-menu.png" alt="" class="" />
            <p class="tool-tip tool-tip-menu">目录</p>
          </div>
          <div class="side-wrap side-wrap-note" @click.stop="toggle(1)">
            <img src="../../images/book/icon-note.png" alt="" class="" />
            <p class="tool-tip tool-tip-note">笔记</p>
          </div>
          <div class="side-wrap side-wrap-mark" @click.stop="toggle(2)">
            <img src="../../images/book/icon-mark.png" alt="" class="" />
            <p class="tool-tip tool-tip-mark">书签</p>
          </div>
        </div>
      </div>
      <el-drawer :visible.sync="drawer" size="500px" :with-header="false">
        <div class="drawer-header">
          <p
            :class="{ 'header-txt': true, 'active-txt': active == index }"
            v-for="(item, index) in tabs"
            :key="item.id"
            @click="onSelect(index)"
          >
            {{ item.title }}
          </p>
        </div>
        <div class="toc-list" v-if="active === 0">
          <div class="" :key="item.id" v-for="item in toc">
            <p
              class="toc-item item-info"
              :class="{ 'active-label': 'id' + (chapter.index + 1) == item.id }"
              @click="gotoDirectory(item)"
            >
              {{ item.label }}
            </p>
            <template v-if="item.subitems && item.subitems.length">
              <p
                class="toc-item item-info-sub"
                :class="{
                  'active-label': 'id' + (chapter.index + 1) == sub.id,
                }"
                v-for="sub in item.subitems"
                :key="sub.id"
                @click="gotoDirectory(item, sub)"
              >
                {{ sub.label }}
              </p>
            </template>
          </div>
        </div>
        <div class="note-list" v-if="active === 1">
          <div class="note-header">
            <p
              :class="{
                'header-note-txt': true,
                'active-txt': activeNote == index,
              }"
              v-for="(item, index) in noteTab"
              :key="item.id"
              @click="onSelectNoteTab(index, item)"
            >
              {{ item.title }}
              <span v-if="item.len > 0">· {{ item.len }}</span>
            </p>
          </div>
          <template v-if="activeNote == 0">
            <div class="empty" v-if="!notes.length">
              <img src="../../images/book/empty.png" alt="" class="" />
              <p class="empty-tip">暂无笔记，阅读时选中文字添加笔记</p>
            </div>

            <div
              class="note-item"
              :key="note.id"
              @click.stop="gotoNote(note)"
              v-for="note in notes"
            >
              <p class="chapter-name">
                {{ note.chapter_name == '未知' ? '' : note.chapter_name }}
              </p>
              <p class="content">{{ note.text }}</p>
              <!-- <div class="mark" :style="{ 'border-color': note.color }">
                {{ note.selectedText }}
              </div> -->
              <div class="note">{{ note.note || '暂无笔记' }}</div>
              <div class="note-footer">
                <p class="time">{{ $actionTool.ts(note.created_at) }}</p>
                <div class="">
                  <img
                    src="../../images/book/icon-del.png"
                    alt=""
                    class=""
                    @click.stop="removeNote(0, note)"
                  />
                  <img
                    src="../../images/book/icon-write-note.png"
                    alt=""
                    class=""
                    @click.stop="editNote(note)"
                  />
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="empty" v-if="!markList.length">
              <img src="../../images/book/empty.png" alt="" class="" />
              <p class="empty-tip">暂无划线，阅读时选中文字添加划线</p>
            </div>
            <div
              class="note-item"
              :key="note.id"
              @click.stop="gotoNote(note)"
              v-for="note in markList"
            >
              <p class="chapter-name">
                {{ note.chapter_name == '未知' ? '' : note.chapter_name }}
              </p>
              <p class="content">{{ note.text }}</p>
              <!-- <div class="mark" :style="{ 'border-color': note.color }">
                {{ note.selectedText }}
              </div> -->
              <div class="note-footer">
                <p class="time">{{ $actionTool.ts(note.created_at) }}</p>
                <div class="">
                  <img
                    src="../../images/book/icon-del.png"
                    alt=""
                    class=""
                    @click.stop="removeNote(1, note)"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="note-list" v-if="active == 2">
          <div class="empty" v-if="!bookmarks.length">
            <img src="../../images/book/icon-empty-lable.png" alt="" class="icon-lable" />
            <p class="empty-tip">暂无书签</p>
          </div>
          <template v-else>
            <div
              class="note-item"
              :key="bookmark.id"
              @click="gotoBookmark(bookmark)"
              v-for="(bookmark, index) in bookmarks"
            >
              <p class="chapter-name">
                {{ bookmark.chapter_name == '未知' ? '' : bookmark.chapter_name }}
              </p>
              <p class="content">书签{{ index + 1 }}</p>
              <!-- <div class="mark" :style="{'border-color': note.color}">{{ note.selectedText }}</div> -->
              <div class="note-footer">
                <p class="time">{{ $actionTool.ts(bookmark.created_at) }}</p>
                <img
                  src="../../images/book/icon-del.png"
                  alt=""
                  class=""
                  @click.stop="removeBookmark(bookmark)"
                />
              </div>
            </div>
          </template>
        </div>
        <div class="" v-if="active == 3">
          <div class="setting-body">
            <el-form ref="form" label-width="80px">
              <el-form-item label="主题">
                <ul class="theme-list">
                  <li
                    class="item"
                    :title="theme.name"
                    v-for="(theme, index) in themes"
                    :key="index"
                    @click="selectTheme(index)"
                    :style="themeStyle(theme.style)"
                  ></li>
                </ul>
              </el-form-item>
              <el-form-item label="正文字体">
                <div class="item-font">
                  <p
                    class="font"
                    @click="onSelectFont(item.value, index)"
                    v-for="(item, index) in fontOptions"
                    :key="item.id"
                    :class="{ 'active-font': activeFont == index }"
                  >
                    {{ item.name }}
                  </p>
                </div>
              </el-form-item>
              <el-form-item label="字体大小">
                <div class="font-size-wrap">
                  <p class="size" @click="onAdjustFont(1)">A-</p>
                  <b></b>
                  <p class="size">{{ defaultFontsize }}</p>
                  <b></b>
                  <p class="size" @click="onAdjustFont(2)">A+</p>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-drawer>
      <el-drawer
        :visible.sync="drawerNote"
        size="500px"
        direction="btt"
        custom-class="drawerNote"
        :with-header="false"
        @close="onCancelNote"
        :modal="false"
      >
        <div class="edit-body">
          <!-- <div class="mark" :style="{'border-color': note.color}">{{ note.selectedText }}</div> -->
          <!-- <textarea class="input" v-model="note.note" placeholder="请输入笔记内容"></textarea> -->
          <el-input
            type="textarea"
            :autosize="{ minRows: 8.5 }"
            placeholder="请输入笔记内容"
            maxlength="150"
            v-model="note"
          ></el-input>
          <div class="note-drawer-footer">
            <el-button type="" @click="onCancelNote">取消</el-button>
            <el-button type="warning" @click="onSaveNote" :disabled="!note"> 保存 </el-button>
          </div>
        </div>
      </el-drawer>
      <div class="page-info" v-if="info">
        {{ info.page }} / {{ info.totalPage }} {{ (info.page / info.totalPage) * 100 }}%
        <!--<div v-if="this.book.currentChapter">当前章节页数：{{ this.book.currentChapter.pages }}</div>-->
      </div>
      <!--select menu 划线，笔记-->
      <div class="select-menu" id="select-menu">
        <div class="action-wrap">
          <div class="action" @click="removeNote(1, currentMark)" v-if="currentMark && !selected">
            <img src="../../images/book/icon-line.png" alt="" class="" />
            <p class="">删除划线</p>
          </div>
          <div class="action" @click="highlightText()" v-if="selected">
            <img src="../../images/book/icon_line_edit.png" alt="" class="" />
            <p class="">划线</p>
          </div>
          <div class="action" @click.stop="editNote">
            <img src="../../images/book/icon-write.png" alt="" class="" />
            <p class="">笔记</p>
          </div>
        </div>
        <div class="triangle"></div>
      </div>
      <!--select menu 查看笔记-->
      <el-drawer
        :visible.sync="lookNote"
        size="500px"
        direction="btt"
        custom-class="drawerNote"
        :with-header="false"
        @close="onCancelNote"
        :modal="false"
      >
        <div class="edit-body">
          <div class="notes" v-for="item in currentNote" :key="item.id">
            <p class="current-note">{{ item.note }}</p>
            <div class="note-drawer-footer look-note-footer">
              <p class="footer-left">{{ $actionTool.ts(item.created_at) }}</p>
              <div class="footer-right">
                <img
                  src="../../images/book/icon-del.png"
                  alt=""
                  class=""
                  @click.stop="removeNote(0, item)"
                />
                <img
                  src="../../images/book/icon-write-note.png"
                  alt=""
                  class=""
                  @click="editNote(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
/* eslint-disable2 */
import { getCoverURL, toChinesNum } from '@/utils/bookUtil';
// const ePub = window.ePub;
// const EPUBJS = window.EPUBJS;
import ePub from 'epubjs';
const QiuPen = window.QiuPen;
import tools from '@/utils/plugins';
import localforage from 'localforage';
export default {
  data() {
    return {
      toChinesNum,
      drawer: false,
      drawerNote: false,
      lookNote: false,
      currentNote: [],
      currentMark: '',
      currentText: '',
      selected: false,
      chapter: '',
      activeFont: 0,
      tabs: [
        { id: 1, title: '目录' },
        { id: 2, title: '笔记' },
        { id: 3, title: '书签' },
        { id: 4, title: '设置' },
      ],
      active: 0,
      noteTab: [
        { id: 2, title: '笔记', len: 0 },
        { id: 1, title: '划线', len: 0 },
      ],
      activeNote: 0,
      markList: [],
      title: 'epub 阅读器',
      info: {
        page: 1,
        totalPage: 10,
      },
      book: null,
      bookInfo: '',
      toc: [],
      meta: null,
      cover: null,
      loading: true,
      // infomation
      open: false,
      infoVisible: false,
      // bookmark
      bookmarkVisible: false,
      bookmarks: [],
      // search
      searchVisible: false,
      keyword: '',
      results: null,
      // note
      noteVisible: false,
      editVisible: false,
      note: '',
      note_id: '',
      notes: [],
      locations: '',
      locationCfi: '',
      // setting
      options: {
        bgColor: '#fff',
        fontSize: 16,
        fontFamily: 'Microsoft Yahei, Heiti SC, Heiti TC',
        lineHeight: 2,
        theme: 0,
        color: '#333',
      },
      themes: [
        {
          name: 'default',
          style: {
            body: {
              color: '#000',
              background: '#fff',
            },
          },
        },
        {
          name: 'eye',
          style: {
            body: {
              color: '#000',
              background: '#ceeaba',
            },
          },
        },
        {
          name: 'gold',
          style: {
            body: {
              color: '#000',
              background: 'rgb(238, 232, 170)', //241.236,226
            },
          },
        },
      ],
      fontOptions: [
        {
          id: 0,
          name: '雅黑',
          value: 'Microsoft Yahei, Heiti SC, Heiti TC',
        },
        {
          id: 1,
          name: '宋体',
          value: 'SimSun, Songti SC, Songti TC',
        },
        {
          id: 2,
          name: '楷书',
          value: 'KaiTi, Kaiti SC, Kaiti TC',
        },
      ],
      highlights: {
        name: 'light',
        color: '#F4242E',
      },
      firstLabel: 0,
      secondLabel: 0,
      currentLabelId: '',
      defaultTheme: 0,
      defaultFontsize: 16,
    };
  },
  computed: {
    // pageStyle() {
    //   return {
    //     color: this.themes[this.options.theme].color,
    //     "background-color": this.themes[this.options.theme].bgColor,
    //   };
    // },
    isMarked() {
      return this.bookmarks.some((item) => {
        return this.locationCfi == item.cfi;
      });
    },
  },
  mounted() {
    this.init();
    this.initEvent();
    // 将vue中的方法赋值给window
    window.onLook = this.onLook;
  },
  destroyed() {
    this.book && this.book.destroy();
    document.removeEventListener('keydown', this.onKeyDown);
  },
  filters: {
    time(value) {
      if (!value) {
        return '';
      }
      return tools.format(new Date(value), 'yyyy-MM-dd');
    },
    simpleTime(value) {
      let date = new Date(value);
      let now = new Date();
      let time = now.getTime() - date.getTime();
      if (time < 60 * 60 * 1000) {
        return parseInt(time / (60 * 1000)) + ' 分钟前';
      } else if (time < 24 * 60 * 1000) {
        return parseInt(time / (24 * 60 * 1000)) + ' 小时前';
      }
      return tools.format(new Date(value), 'yyyy-MM-dd');
    },
  },
  methods: {
    async onLook($event, value) {
      console.log($event);
      console.log(value);
      this.selected = false;
      this.currentNote = this.notes.filter((item) => value.indexOf(item.text) > -1);
      this.currentMark = this.markList.find(
        (item) => value.length >= 2 && (item.text == value || item.text.indexOf(value) > -1),
      );
      console.log(this.currentMark);
      this.selectedText = value;
      if (this.currentNote.length || this.currentMark) {
        let menu = window.parent.document.getElementById('select-menu');
        menu.style.left = $event.offsetX + 'px';
        menu.style.top = $event.clientY + 'px';
        menu.style.visibility = 'visible';
      }
      if (this.currentNote.length) {
        this.lookNote = true;
      }
    },
    //设置主题色
    themeStyle(theme) {
      return {
        'background-color': theme.body.background,
      };
    },

    selectTheme(index) {
      console.log('theme', index);
      this.rendition.themes.select(this.themes[index].name);
      localStorage.setItem('theme', index);
    },
    onSelectFont(value, index) {
      this.activeFont = index;
      localStorage.setItem('fontFamily', value);
      this.rendition.themes.font(value);
    },
    onAdjustFont(type) {
      if (type == 1) {
        this.options.fontSize--;
      } else {
        this.options.fontSize++;
      }
      this.setFontSize(this.options.fontSize);
    },
    setFontSize(fontSize) {
      this.defaultFontsize = fontSize;
      localStorage.setItem('fontSize', fontSize);
      if (this.rendition.themes) {
        this.rendition.themes.fontSize(fontSize + 'px');
      }
    },
    registerTheme() {
      this.themes.forEach((theme) => {
        this.rendition.themes.register(theme.name, theme.style);
      });
    },
    onBack() {
      this.$router.back();
    },
    onCancelNote() {
      this.drawerNote = false;
      this.note = '';
    },
    //保存笔记
    onSaveNote() {
      let name = 'hl-' + this.highlights.name;
      QiuPen.highlighter.highlightSelection(name);
      QiuPen.save(
        this.chapter,
        this.bookId,
        this.chapter.document.title,
        this.note,
        this.selectedText,
        this.locationCfi,
        this.highlights.color,
        2,
        this.note_id,
      );
      setTimeout(() => {
        this.loadNote(2);
      }, 300);
      document.getElementById('select-menu').style.visibility = 'hidden';
      this.drawerNote = false;
      this.lookNote = false;
    },
    onSelect(index) {
      this.active = index;
    },
    onSelectNoteTab(index, item) {
      this.activeNote = index;
      this.loadNote(item.id);
    },
    //编辑笔记
    editNote(note) {
      this.lookNote = false;
      document.getElementById('select-menu').style.visibility = 'hidden';
      setTimeout(() => {
        console.log(note, 'note');
        if (note.note) {
          this.note = note.note;
          this.note_id = note.id;
        }
        this.drawerNote = true;
        console.log(this.note);
      }, 500);
    },
    async removeNote(type, note) {
      this.activeNote = type;
      console.log(type, 'type');
      let iframe = document.getElementsByTagName('iframe')[0];
      console.log(window.rangy.getSelection(iframe.contentDocument), 'selection');
      if (this.activeNote == 0) {
        await this.$promiseConfirm('删除后，该笔记内容将无法恢复');
      }
      console.log(note);
      await this.$http.delete(`/api/app/myEbook/note/${note.id}`);
      document.getElementById('select-menu').style.visibility = 'hidden';
      console.log(this.currentNote, 'this.currentNote');
      //手动去除选中文本的划线
      if (window.rangy.getSelection(iframe.contentDocument).focusNode) {
        if (this.activeNote == 0 && this.currentNote.length == 1) {
          window.rangy
            .getSelection(iframe.contentDocument)
            .focusNode.parentNode.classList.remove('hl-light');
          this.removeHighlight(window.rangy.getSelection(iframe.contentDocument));
        } else if (this.activeNote == 1) {
          console.log(
            window.rangy.getSelection(iframe.contentDocument),
            'window.rangy.getSelection(iframe.contentDocument)',
          );
          window.rangy
            .getSelection(iframe.contentDocument)
            .focusNode.parentNode.classList.remove('line-light');
          this.removeHighlight(window.rangy.getSelection(iframe.contentDocument));
        }
      }
      this.lookNote = false;
      setTimeout(() => {
        this.loadNote(this.activeNote == 0 ? 2 : 1);
      }, 600);
    },
    removeHighlight(selection) {
      QiuPen.highlighter.unhighlightSelection(selection);
      QiuPen.resetSave(this.chapter, this.bookId, this.currentMark.text);
    },
    //划线文本
    highlightText() {
      let name = 'line-' + this.highlights.name;
      QiuPen.highlighter.highlightSelection(name);
      QiuPen.save(
        this.chapter,
        this.bookId,
        this.chapter.document.title,
        this.note,
        this.selectedText,
        this.locationCfi,
        this.highlights.color,
        1,
      );
      setTimeout(() => {
        this.loadNote(1);
      }, 300);
      document.getElementById('select-menu').style.visibility = 'hidden';
      this.lookNote = false;
    },
    // url资源转换为arraybuffer
    getArraybuffer(url) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('get', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(new Error('异常'));
          }
        };
        xhr.send();
        xhr.onerror = () => {
          reject(new Error('异常'));
        };
      });
    },
    async init() {
      // document.getElementById("area").style.height =
      //   window.innerHeight - 100 + "px";
      let bookId = this.$route.params.id;
      this.bookId = bookId;
      // TODO
      if (!this.bookId) {
        return;
      }
      //加载书籍
      this.loading = true;
      const res = await this.$http.get(
        `/api/app/myEbook/${bookId},`,
        {},
        {
          showLoading: false,
        },
      );
      this.bookInfo = res;
      // 读取indexedb数据 如果未取到则访问网络资源
      // const file = await this.dbOperation("get", 2);
      const file = await localforage.getItem(res.file);
      if (file) {
        this.loadBook(file);
      } else {
        // url 转换 Arraybuffer
        this.getArraybuffer(res.file).then(async (blob) => {
          // 数据存入indexedb
          // const data = await this.dbOperation("add", blob);
          // console.log(data);
          localforage.setItem(res.file, blob);
          this.loadBook(blob);
        });
      }
      this.getBookMark();
      this.loadNote(2);
      this.loadNote(1);
    },
    async getBookMark() {
      // get bookmarks 获取书签
      const bookMarkRes = await this.$http.get(
        '/api/app/myEbook/label',
        {
          ebook_id: this.bookId,
        },
        {
          showLoading: false,
        },
      );
      this.bookmarks = bookMarkRes;
    },
    async removeBookmark(bookmark) {
      await this.$http.delete(`/api/app/myEbook/label/${bookmark.id}`);
      this.$message({
        type: 'success',
        message: '删除成功',
      });
      this.getBookMark();
    },
    //移除书签
    async removeBookMarkIcon() {
      for (let item of this.bookmarks) {
        if (item.cfi == this.locationCfi) {
          this.currentLabelId = item.id;
          break;
        }
      }
      await this.$http.delete(`/api/app/myEbook/label/${this.currentLabelId}`);
      this.getBookMark();
    },
    // 增加书签
    async addBookmark() {
      console.log(this.book, 'book');
      this.bookmarks.unshift({
        ebook_id: this.bookId, // TODO
        chapter: this.book.spinePos,
        chapter_name: this.chapter.document.title,
        cfi: this.locationCfi,
        text: this.currentText, // TODO
        createTime: new Date().getTime(),
        posY: 1, // TODO
      });
      await this.$http.post('/api/app/myEbook/label', this.bookmarks[0]);
      this.getBookMark();
    },
    //每章节后面有一个空白页，去除一页。章节变化的时候，拿到的width不对，有延迟
    resetWidth() {
      let iframe = document.getElementsByTagName('iframe')[0];
      let viewWidth = document.getElementsByClassName('epub-view')[0].clientWidth;
      let iframeWidth = iframe.clientWidth;
      document.getElementsByClassName('epub-view')[0].style.width = viewWidth - 912 + 'px';
      iframe.style.width = iframeWidth - 912 + 'px';
    },
    loadBook(file) {
      console.log(file);
      this.book = ePub(file, {});
      this.rendition = this.book.renderTo('area', {
        width: 912, //width和height可以设置图书内容的宽和高，默认值是不设置，此时会填满父窗口。
        height: false,
        spread: 'none',
        methods: 'default',
      });
      // if (localStorage.getItem(this.bookId)) {
      //   this.book.goto(localStorage.getItem(this.bookId));
      // }
      // this.setStyle();

      console.log(this.book, 'book书本');
      console.log(this.rendition, 'book');
      this.book.loaded.metadata.then((meta) => {
        this.title = meta.title + ' – ' + meta.creator;
      });
      this.book.loaded.navigation.then((toc) => {
        this.toc = toc.toc;
      });
      // 注册主题
      this.registerTheme();
      this.selectTheme(
        localStorage.getItem('theme') ? localStorage.getItem('theme') : this.defaultTheme,
      );
      // // 设置默认字体大小
      this.setFontSize(
        localStorage.getItem('fontSize') ? localStorage.getItem('fontSize') : this.defaultFontsize,
      );
      // // 设置默认字体
      this.onSelectFont(
        localStorage.getItem('fontFamily')
          ? localStorage.getItem('fontFamily')
          : this.defaultFontsize,
      );
      this.book.ready.then(() => {
        // console.log(this.book)
        getCoverURL(this.book, (cover) => {
          this.cover = cover;
        });
        this.locations = this.book.locations;
        if (localStorage.getItem(this.bookId)) {
          this.rendition.display(localStorage.getItem(this.bookId)).then(() => {
            this.loading = false;
          });
        } else {
          this.rendition.display().then(() => {
            this.loading = false;
          });
        }
        this.initAfterLoadedBook();
        return this.book.locations.generate(); //分页
      });
      // this.book.renderer.forceSingle(true);
      // epub.js能捕获用户在书籍上的鼠标释放事件，使用self.selected是为了防止用户重复选中。
      // 监听 章节渲染
      this.rendition.on('rendered', (chapter) => {
        console.log(chapter, 'chapter章节变化');
        this.chapter = chapter;
        this.currentText = chapter.document.body.innerText;
        // console.log(chapter.contents.body.innerText, "chapter");
        // 创建动态脚本
        function createScript(url) {
          let script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = url;
          return script;
        }

        // 创建动态样式表
        function createLink(url) {
          let link = document.createElement('link');
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = url;
          return link;
        }

        let link = createLink('/epub/common.css');
        let linkFont = createLink('/font/iconfont.css');
        let script = createScript('/epub/selection.js');
        let iframe = document.getElementsByTagName('iframe')[0];
        //获取电子书所有视频, 禁止视频下载
        let videos = iframe.contentDocument.getElementsByTagName('video');
        if (videos.length) {
          for (let item of videos) {
            item.setAttribute('controlslist', 'nodownload');
          }
        }
        iframe.contentDocument.head.appendChild(link);
        iframe.contentDocument.head.appendChild(linkFont);
        iframe.contentDocument.body.appendChild(script);
        this.resetWidth();

        QiuPen.create(iframe.contentDocument);
        QiuPen.load(this.chapter, this.bookId);
      });
      this.rendition.on('locationChanged', (locationCfi) => {
        console.log(locationCfi, 'locationCfi');
        this.locationCfi = locationCfi.end;
        this.rememberLocation();
        // let iframe = document.getElementsByTagName("iframe")[0];
        // console.log(iframe, "contentDocument");
        // this.currentText = iframe.contentDocument.body.innerText;
        // this.getProgress(locationCfi);
      });
      let that = this;
      this.rendition.on('selected', (cfiRange) => {
        // 释放后检测用户选中的文字
        // let render = this.book.renderer.render;
        // let selectedContent = render.window.getSelection();
        // this.selection = selectedContent;
        // console.log(this.selection);
        // console.log(
        //   this.selection.anchorNode.data.substring(
        //     this.selection.baseOffset,
        //     this.selection.extentOffset,
        //   ),
        // );
        // this.selectedText = this.selection.anchorNode.data.substring(
        //   this.selection.baseOffset,
        //   this.selection.extentOffset,
        // );
        this.book.getRange(cfiRange).then(function (range) {
          console.log(range, 'range');
          if (range) {
            // that.rendition.annotations.underline(cfiRange);
            const text = range.toString();
            if (text && text !== '') {
              that.selectedText = text;
              that.selected = true;
              console.log('text--------');
            }
            console.log(that.selectedText, '当前选中文本');
            // that.addNotes(text,cfiRange)
          }
        });
      });
    },
    // 获取笔记列表
    async loadNote(type) {
      // get notes
      const res = await this.$http.get(
        '/api/app/myEbook/note',
        {
          ebook_id: this.bookId,
          type,
        },
        {
          showLoading: false,
        },
      );
      if (type == 1) {
        this.markList = res;
        this.$set(this.noteTab[1], 'len', this.markList.length);
      } else {
        this.notes = res.filter((item) => item.note);
        this.$set(this.noteTab[0], 'len', this.notes.length);
      }
    },
    initAfterLoadedBook() {
      QiuPen.init();
      this.loading = false;
    },
    initEvent() {
      document.addEventListener(
        'keydown',
        (this.onKeyDown = (e) => {
          console.log(e.keyCode);
          switch (e.keyCode) {
            case 27: // Esc
              this.$router.push('/');
              break;
            case 37: // left
            case 38: // up
              this.prev();
              break;
            case 39: // right
            case 40: // down
              this.next();
              this.book.nextPage();
              break;
          }
        }),
        false,
      );
    },
    // 阅读进度条更新
    async getProgress() {
      // 获取当前位置信息
      const currentLoction = this.rendition.currentLocation();
      // 获取当前位置进度百分比
      let progress = currentLoction ? this.locations.percentageFromCfi(currentLoction.end.cfi) : 0;
      // 转化成0-100的数字
      // progress = Math.round(progress * 100);
      await this.$http.post('/api/app/myEbook/record', {
        ebook_id: this.bookId,
        progress,
      });
    },
    prev() {
      this.info.page--;
      this.rendition.prev().then(() => {
        this.getProgress();
      });
    },
    next() {
      this.info.page++;
      this.rendition.next().then(() => {
        this.getProgress();
      });
    },
    toggle(active) {
      this.drawer = !this.drawer;
      this.active = active;
    },
    toggleNote() {
      this.noteVisible = !this.noteVisible;
      this.editVisible = false;
    },
    gotoDirectory(item, sub) {
      this.drawer = false;
      this.firstLabel = item.label;
      if (sub) {
        this.gotoCfi(sub.href);
        this.secondLabel = sub.label;
      } else {
        this.gotoCfi(item.href);
      }
    },
    gotoBookmark(bookmark) {
      this.gotoCfi(bookmark.cfi);
      this.bookmarkVisible = false;
    },
    gotoCfi(cfi) {
      this.rendition.display(cfi).then(() => {});
      // this.getProgress(cfi);
    },
    gotoNote(note) {
      this.gotoCfi(note.cfi);
    },
    rememberLocation() {
      localStorage.setItem(this.bookId, this.locationCfi);
    },
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开当前路由的时候被调用，this可以被访问到
    console.log('导航离开当前路由');
    this.rememberLocation();
    this.getProgress();
    next();
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 1000px;
}
.page-reader {
  background: #f5f5f5;
  position: relative;
}
.tool-tip {
  color: #333;
  padding: 8px;
  background: #fff;
  position: absolute;
  bottom: -30px;
  right: -63px;
  border-radius: 3px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  opacity: 0;
}
.book-header {
  width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #ededed;
  height: 72px;
  .book-header-left {
    display: flex;
    align-items: center;
    position: relative;
    &:hover {
      .tool-tip-back {
        opacity: 1;
      }
    }
    .tool-tip {
      left: 20px;
      z-index: 9999;
      width: 88px;
    }
    img {
      width: 20px;
      margin-right: 15px;
      cursor: pointer;
    }
    .book-name {
      font-size: 16px;
      margin: 0;
      font-weight: bold;
    }
    .book-chapter {
      margin: 0;
      margin-left: 20px;
      color: #999;
    }
  }
  .add-note-tip {
    width: 88px;
    color: #333;
    padding: 8px;
    background: #fff;
    position: absolute;
    top: 30px;
    right: -110px;
    opacity: 0;
    border-radius: 3px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  }
  .book-mark {
    cursor: pointer;
    position: relative;
    &:hover {
      .add-note-tip {
        opacity: 1;
      }
    }
    img {
      width: 14px;
      height: 62px;
    }
  }
}
// .el-drawer__wrapper{
//     right:18%
// }
.drawer-header {
  display: flex;
  height: 72px;
  background: #f7f7f7;
  padding: 0 40px;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  color: #666;
}
.active-txt {
  font-weight: bold;
  color: #333;
}
.toc-list {
  padding: 0 20px;
  .toc-item {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #f5f5f5;
    margin: 0;
    cursor: pointer;
  }
  .item-info-sub {
    margin-left: 30px;
  }
  .active-label {
    color: $primary-color !important;
  }
}
.note-list {
  position: relative;
  min-height: calc(100% - 140px);
  .note-header {
    height: 52px;
    padding: 0 110px;
    background: #f7f7f7;
    color: #666;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e8e8e8;
  }
  .note-item {
    border-bottom: 1px solid #f5f5f5;
    margin: 0 20px;
    cursor: pointer;
    .chapter-name {
      padding-top: 15px;
      font-size: 16px;
      font-weight: bold;
    }
    .content {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin-top: 10px;
    }
    .note {
      color: #999999;
      margin-top: 10px;
    }
  }
  .note-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      color: #999;
    }
    img {
      padding: 10px;
      cursor: pointer;
    }
  }
  .empty {
    position: absolute;
    top: 262px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    img {
      width: 300px;
      height: 170px;
    }
    .empty-tip {
      color: #999;
    }
  }
}
/* 选中菜单 */
.select-menu {
  position: absolute;
  width: 100px;
  padding: 3px 0;
  background-color: #3d3d3d;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.14);
  border: 1px solid rgba(27, 31, 35, 0.15);
  border-radius: 12px;
  z-index: 3000;
  visibility: hidden;
  .triangle {
    position: absolute;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-top: 10px solid #3d3d3d;
    bottom: -16px;
    left: 50%;
    margin-left: -5px;
  }
}
.action-wrap {
  display: flex;
  justify-content: center;
  justify-content: space-around;
}
.action {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-size: 10px;
  img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  p {
    margin: 0;
    cursor: pointer;
  }
}
.arrow {
  position: absolute;
  top: 50%;
  margin-top: -32px;
  font-size: 64px;
  color: #e2e2e2;
  font-family: arial, sans-serif;
  font-weight: bold;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  &:hover {
    color: #777;
  }
  &:active {
    color: #000;
  }
}

#wrapper {
  max-width: 1000px;
  // padding: 16px;
  // width: 480px;
  // height: 640px;
  margin: 0 auto;
  // overflow: hidden;
  // border: 1px solid #ccc;
  background: #fff;
  border-radius: 0 5px 5px 0;
  position: relative;
  padding: 16px 44px;
}
.rightSide {
  position: absolute;
  bottom: 20px;
  right: -68px;
  .side-wrap {
    background: #fff;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    img {
      width: 26px;
      height: 26px;
    }
  }
  .side-wrap-next {
    &:hover {
      .tool-tip-next {
        opacity: 1;
      }
    }
  }
  .side-wrap-prev {
    &:hover {
      .tool-tip-prev {
        opacity: 1;
      }
    }
  }
  .side-wrap-menu {
    &:hover {
      .tool-tip-menu {
        opacity: 1;
        right: -50px;
      }
    }
  }
  .side-wrap-note {
    &:hover {
      .tool-tip-note {
        opacity: 1;
        right: -50px;
      }
    }
  }
  .side-wrap-mark {
    &:hover {
      .tool-tip-mark {
        opacity: 1;
        right: -50px;
      }
    }
  }
}
.page-divider {
  display: none;
  position: absolute;
  width: 1px;
  border-right: 1px #000 solid;
  height: 80%;
  z-index: 1;
  left: 50%;
  margin-left: -1px;
  top: 10%;
  opacity: 0.15;
}
.page-info {
  display: none;
  position: absolute;
  left: 16px;
  bottom: 16px;
}
.drawer-body {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
.info-drawer {
  width: 320px;
  max-width: 100%;
  .info-body {
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    padding: 16px;
    .key {
      width: 100px;
    }
    .cover {
      margin-bottom: 0;
    }
  }
}

::v-deep .drawerNote {
  background: #313233;
  border-radius: 8px 8px 0px 0px;
  // backdrop-filter: blur(15px);
  height: 264px !important;
  width: 1000px !important;
  margin: 0 auto;
  .el-textarea__inner {
    background: #313233;
    // backdrop-filter: blur(15px);
    border: 0;
    color: #fff;
  }
}
.edit-body {
  padding: 16px;
  .time {
    margin-bottom: 16px;
  }
  .mark {
    padding: 8px 16px;
    margin-bottom: 16px;
    border-left: 8px solid #09c;
    max-height: 54px;
    overflow: hidden;
  }
  .note {
    color: #999;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .current-note {
    color: #fff;
    line-height: 26px;
  }
  .note-drawer-footer {
    display: flex;
    justify-content: flex-end;
    .footer-left {
      color: #999;
      font-size: 10px;
    }
    img {
      cursor: pointer;
      margin-left: 15px;
    }
  }
  .look-note-footer {
    justify-content: space-between;
  }
}
.setting-body {
  padding: 20px;
}
.theme-list {
  overflow: hidden;
  margin-top: 4px;
  .item {
    float: left;
    width: 28px;
    height: 28px;
    margin-right: 16px;
    margin-bottom: 16px;
    border: 1px solid #999;
    border-radius: 50%;
    background-color: #000;
    cursor: pointer;
  }
}
.item-font {
  display: flex;
  align-items: center;
  .font {
    width: 78px;
    height: 34px;
    margin-right: 16px;
    border: 1px solid #e5e5e5;
    border-radius: 2px;
    background: #fff;
    text-align: center;
    line-height: 34px;
    cursor: pointer;
  }
  .active-font {
    color: $primary-color;
    border: 1px solid $primary-color;
    background: #fff0f2;
  }
}
.font-size-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #e5e5e5;
  border-radius: 2px;
  width: 270px;
  .size {
    width: 89px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
  }
  b {
    display: inline-block;
    height: 20px;
    vertical-align: middle;
    border-right: 1px solid #e5e5e5;
  }
}
.form-label {
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 8px;
}
.highlight-list {
  overflow: hidden;
  padding-left: 16px;
  .item {
    float: left;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    margin-bottom: 8px;
    background-color: #f00;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.toc-drawer {
  width: 400px;
  max-width: 100%;
  .ui-item-title {
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.search-drawer {
  width: 400px;
  max-width: 100%;
  .search-body {
    padding: 16px;
    .key {
      width: 100px;
    }
  }
  .result-list {
    position: absolute;
    top: 128px;
    left: 0;
    right: 0;
    bottom: 0;
    border-top: 1px solid #eee;
    overflow: auto;
    .item {
      padding: 16px;
      border-bottom: 1px solid #eee;
      &:hover {
        background-color: #f9f9f9;
      }
    }
    .link {
      color: #666;
    }
    .keyword {
      color: #009688;
      font-weight: bold;
    }
  }
}
</style>
